import _ from 'lodash';

import { isTaskThreadReply } from 'models/composition/task_thread_reply_composition_content';

// The drafts that belong to the composer. A task side conversation reply is a composition too, but it
// lives in the task panel, so the composer's tabs, focus and limits never see it.
export function findComposerCompositions(compositionsStore, query) {
  return _.reject(compositionsStore.findAll(query), isTaskThreadReply);
}

export function findOpenComposerCompositions(compositionsStore, query) {
  return _.reject(findComposerCompositions(compositionsStore, query), c => compositionsStore.isPendingDelete(c.id));
}

export function findTaskThreadReplyComposition(compositionsStore, taskId) {
  return _.find(
    compositionsStore.findAll(),
    composition =>
      isTaskThreadReply(composition) &&
      composition.content.taskId === taskId &&
      !compositionsStore.isPendingDelete(composition.id)
  );
}
